module.exports = __webpack_public_path__ + "static/img/bpm.0efb07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bpm.jpg
// module id = u3sf
// module chunks = 0